// extracted by mini-css-extract-plugin
export default {"icon":"lONTD","info":"HTbch","logoutLogo":"W4o4P"};